import DeleteRequest from "../../service/DeleteRequest";
import GetRequest from "../../service/GetRequest";

export const BranchService = {
    
    async getBranchsData() {
        try {
            const response = await GetRequest(`v1/store-management-service/view/my/store`,true);

            if (!response || response.length === 0) {
                console.log("Empty response or undefined data for categories");
                return []; // Return an empty array if response is empty or undefined
            } else {
                return response.storeBranches; // Return the response array
            }
        } catch (error) {
            console.error("Error fetching Branch data:", error);
            return []; // Return an empty array in case of error
        }
    },


    async deleteBranch(storeId, branchId) {
        try {
            await DeleteRequest(`v1/store-management-service/store/${storeId}/remove/branch/${branchId}`, true);
        } catch (error) {
            console.error("Error deleting Branch:", error);
            throw error; // Re-throw the error to be handled by the caller
        }
    },

    getBranches() {
        return Promise.resolve(this.getBranchsData());
    },

    deleteBranches(storeId, branchId) {
        return this.deleteBranch(storeId, branchId);
    }

};
